import {PageQuestions} from './PageQuestions';
import {AspectAnswers} from '../AspectAnswers';
import {AnswerReference} from '../Answer';


/**
 * @deprecated use `SectionAnswers2`
 */
export class SectionAnswers1 {

  answers: AnswerReference[] = [];

  constructor(public questions: PageQuestions, answers: AspectAnswers ) {

    for( const q of questions.questions ) {
      this.answers.push( answers.getAnswer( q ) );
    }
  }

}
